import validate from "/home/ubuntu/Lagerverwaltung/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/ubuntu/Lagerverwaltung/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/home/ubuntu/Lagerverwaltung/middleware/admin.ts"),
  "sidebase-auth": () => import("/home/ubuntu/Lagerverwaltung/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}